var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-form-inline',[_c('mdb-input',{staticClass:"mr-sm-2",attrs:{"type":"text","placeholder":"Szukaj...","aria-label":"Search"},model:{value:(_vm.phrase),callback:function ($$v) {_vm.phrase=$$v},expression:"phrase"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }